"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Const_1 = __importDefault(require("../Const"));
const zod_1 = __importDefault(require("zod"));
var User;
(function (User) {
    let Language;
    (function (Language) {
        Language.languageSchema = zod_1.default.object({
            languageCode: zod_1.default.nativeEnum(Const_1.default.languageCode),
            proficiency: zod_1.default.number(),
            learning: zod_1.default.boolean(),
        });
        const createParamsBaseSchema = zod_1.default.object({ languageCode: zod_1.default.nativeEnum(Const_1.default.languageCode) });
        Language.createParamsSchema = zod_1.default.discriminatedUnion("target", [
            createParamsBaseSchema.extend({ target: zod_1.default.literal(true), proficiency: zod_1.default.number() }),
            createParamsBaseSchema.extend({ target: zod_1.default.literal(false), proficiency: zod_1.default.literal(1) }),
        ]);
        Language.createReturnSchema = zod_1.default.object({});
        Language.deleteParamsSchema = zod_1.default.object({ languageCode: zod_1.default.nativeEnum(Const_1.default.languageCode) });
        Language.deleteReturnSchema = zod_1.default.object({});
        Language.listParamsSchema = zod_1.default.object({ userId: zod_1.default.string().uuid().optional() });
        Language.listReturnSchema = zod_1.default.object({
            languages: zod_1.default
                .object({
                languageCode: zod_1.default.nativeEnum(Const_1.default.languageCode),
                proficiency: zod_1.default.number(),
                learning: zod_1.default.boolean(),
            })
                .array(),
        });
        class Adapter {
            constructor(params) {
                this.api = params.api;
            }
            create(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const data = Language.createParamsSchema.parse(params);
                    const response = yield this.api.request({ data, method: "POST", path: "/user/language" });
                    return Language.createReturnSchema.parse(response);
                });
            }
            delete(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { languageCode } = Language.deleteParamsSchema.parse(params);
                    const response = yield this.api.request({ method: "DELETE", path: `/user/language/${languageCode}` });
                    return Language.deleteReturnSchema.parse(response);
                });
            }
            list(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { userId } = Language.listParamsSchema.parse(params);
                    let path = "/user/";
                    if (userId)
                        path += `${userId}/`;
                    path += "language";
                    const response = yield this.api.request({ method: "GET", path });
                    return Language.listReturnSchema.parse(response);
                });
            }
        }
        Language.Adapter = Adapter;
    })(Language = User.Language || (User.Language = {}));
    User.userSchema = zod_1.default.object({
        createdAt: zod_1.default.coerce.date(),
        dailyGoal: zod_1.default.nativeEnum(Const_1.default.dailyGoal),
        description: zod_1.default.string(),
        email: zod_1.default.string().nullable(),
        googleUserId: zod_1.default.string().nullable(),
        interests: zod_1.default.string().array(),
        name: zod_1.default.string(),
        phone: zod_1.default.string().nullable(),
        profileImageUrl: zod_1.default.string(),
        updatedAt: zod_1.default.coerce.date(),
        userId: zod_1.default.string(),
    });
    User.profileBaseSchema = zod_1.default.object({
        createdAt: zod_1.default.coerce.date(),
        description: zod_1.default.string(),
        name: zod_1.default.string(),
        profileImageUrl: zod_1.default.string(),
        userId: zod_1.default.string(),
    });
    User.profileSchema = User.profileBaseSchema.extend({ languages: Language.languageSchema.array() });
    let Preference;
    (function (Preference) {
        const upn = Const_1.default.userPreferenceName;
        // Add all user preferences here
        Preference.list = {
            [upn.dailyDigestNotification]: { default: true, schema: zod_1.default.boolean() },
            [upn.newChatMessageNotification]: { default: true, schema: zod_1.default.boolean() },
        };
        Preference.loadParamsSchema = zod_1.default.object({ name: zod_1.default.nativeEnum(Const_1.default.userPreferenceName) });
        Preference.loadReturnSchema = zod_1.default.object({
            name: zod_1.default.nativeEnum(Const_1.default.userPreferenceName),
            value: zod_1.default.union([zod_1.default.boolean(), zod_1.default.number(), zod_1.default.string()]),
        });
        Preference.setParamsSchema = zod_1.default.object({
            name: zod_1.default.nativeEnum(Const_1.default.userPreferenceName),
            value: zod_1.default.union([zod_1.default.boolean(), zod_1.default.number(), zod_1.default.string()]),
        });
        Preference.setReturnSchema = zod_1.default.object({});
        class Adapter {
            constructor(params) {
                this.api = params.api;
            }
            load(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { name } = Preference.loadParamsSchema.parse(params);
                    const response = yield this.api.request({ method: "GET", path: `/user/preference/${name}` });
                    return Preference.loadReturnSchema.parse(response);
                });
            }
            set(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const _a = Preference.setParamsSchema.parse(params), { name } = _a, data = __rest(_a, ["name"]);
                    const response = yield this.api.request({ data, method: "POST", path: `/user/preference/${name}` });
                    return Preference.setReturnSchema.parse(response);
                });
            }
        }
        Preference.Adapter = Adapter;
    })(Preference = User.Preference || (User.Preference = {}));
    let Schedule;
    (function (Schedule) {
        Schedule.scheduleSlotBaseSchema = zod_1.default.object({
            duration: zod_1.default.number(), // in minutes
            scheduleSlotId: zod_1.default.string().uuid(),
            startsAt: zod_1.default.coerce.date(),
        });
        Schedule.scheduleSlotSchema = Schedule.scheduleSlotBaseSchema.extend({
            bookedByUserId: zod_1.default.string().uuid().nullable(),
            createdAt: zod_1.default.coerce.date(),
            updatedAt: zod_1.default.coerce.date(),
            userId: zod_1.default.string().uuid(),
        });
        Schedule.createParamsSchema = zod_1.default.object({
            duration: zod_1.default.union([zod_1.default.literal(15), zod_1.default.literal(30), zod_1.default.literal(45), zod_1.default.literal(60)]),
            startsAt: zod_1.default.coerce.date(),
        });
        Schedule.createReturnSchema = Schedule.scheduleSlotSchema;
        Schedule.deleteParamsSchema = zod_1.default.object({ scheduleSlotId: zod_1.default.string().uuid() });
        Schedule.deleteReturnSchema = zod_1.default.object({});
        Schedule.queryParamsSchema = zod_1.default.object({
            limit: zod_1.default.number().optional(),
            offset: zod_1.default.number().optional(),
            start: zod_1.default.coerce.date().optional(),
            userId: zod_1.default.string().uuid(),
        });
        Schedule.queryReturnSchema = zod_1.default.object({ count: zod_1.default.number(), slots: Schedule.scheduleSlotBaseSchema.array() });
        Schedule.queryOwnParamsSchema = zod_1.default.object({
            limit: zod_1.default.number().optional(),
            offset: zod_1.default.number().optional(),
            start: zod_1.default.coerce.date().optional(),
        });
        Schedule.queryOwnReturnSchema = zod_1.default.object({
            count: zod_1.default.number(),
            slots: Schedule.scheduleSlotSchema.extend({ bookedByUser: User.profileBaseSchema.nullable() }).array(),
        });
        Schedule.queryAppointmentsParamsSchema = zod_1.default.object({
            limit: zod_1.default.number().optional(),
            offset: zod_1.default.number().optional(),
            start: zod_1.default.coerce.date().optional(),
        });
        Schedule.queryAppointmentsReturnSchema = zod_1.default.object({
            count: zod_1.default.number(),
            slots: Schedule.scheduleSlotSchema.extend({ bookedByUser: User.profileBaseSchema, user: User.profileBaseSchema }).array(),
        });
        Schedule.bookSlotParamsSchema = zod_1.default.object({
            message: zod_1.default.string().optional(),
            scheduleSlotId: zod_1.default.string().uuid(),
            userId: zod_1.default.string().uuid(),
        });
        Schedule.bookSlotReturnSchema = zod_1.default.object({});
        Schedule.cancelBookingParamsSchema = zod_1.default.object({ scheduleSlotId: zod_1.default.string().uuid(), userId: zod_1.default.string().uuid() });
        Schedule.cancelBookingReturnSchema = zod_1.default.object({});
        class Adapter {
            constructor(params) {
                this.api = params.api;
            }
            create(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const data = Schedule.createParamsSchema.parse(params);
                    const response = yield this.api.request({ data, method: "POST", path: "/user/schedule" });
                    return Schedule.createReturnSchema.parse(response);
                });
            }
            delete(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { scheduleSlotId } = Schedule.deleteParamsSchema.parse(params);
                    const response = yield this.api.request({ method: "DELETE", path: `/user/schedule/${scheduleSlotId}` });
                    return Schedule.deleteReturnSchema.parse(response);
                });
            }
            queryOwn(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { limit, offset, start } = Schedule.queryOwnParamsSchema.parse(params);
                    let path = `/user/schedule`;
                    const queryParams = new URLSearchParams();
                    if (start)
                        queryParams.append("start", start.toISOString());
                    if (limit)
                        queryParams.append("limit", limit.toString());
                    if (offset)
                        queryParams.append("offset", offset.toString());
                    const queryString = queryParams.toString();
                    if (queryString)
                        path += `?${queryString}`;
                    const response = yield this.api.request({ method: "GET", path });
                    return Schedule.queryOwnReturnSchema.parse(response);
                });
            }
            queryAppointments(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { limit, offset, start } = Schedule.queryAppointmentsParamsSchema.parse(params);
                    let path = `/user/schedule/appointments`;
                    const queryParams = new URLSearchParams();
                    if (start)
                        queryParams.append("start", start.toISOString());
                    if (limit)
                        queryParams.append("limit", limit.toString());
                    if (offset)
                        queryParams.append("offset", offset.toString());
                    const queryString = queryParams.toString();
                    if (queryString)
                        path += `?${queryString}`;
                    const response = yield this.api.request({ method: "GET", path });
                    return Schedule.queryAppointmentsReturnSchema.parse(response);
                });
            }
            query(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { limit, offset, start, userId } = Schedule.queryParamsSchema.parse(params);
                    let path = `/user/${userId}/schedule`;
                    const queryParams = new URLSearchParams();
                    if (start)
                        queryParams.append("start", start.toISOString());
                    if (limit)
                        queryParams.append("limit", limit.toString());
                    if (offset)
                        queryParams.append("offset", offset.toString());
                    const queryString = queryParams.toString();
                    if (queryString)
                        path += `?${queryString}`;
                    const response = yield this.api.request({ method: "GET", path });
                    return Schedule.queryReturnSchema.parse(response);
                });
            }
            bookSlot(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { scheduleSlotId, userId } = Schedule.bookSlotParamsSchema.parse(params);
                    const response = yield this.api.request({
                        method: "POST",
                        path: `/user/${userId}/schedule/${scheduleSlotId}/book`,
                    });
                    return Schedule.bookSlotReturnSchema.parse(response);
                });
            }
            cancelBooking(params) {
                return __awaiter(this, void 0, void 0, function* () {
                    const { scheduleSlotId, userId } = Schedule.cancelBookingParamsSchema.parse(params);
                    const response = yield this.api.request({
                        method: "POST",
                        path: `/user/${userId}/schedule/${scheduleSlotId}/cancel`,
                    });
                    return Schedule.cancelBookingReturnSchema.parse(response);
                });
            }
        }
        Schedule.Adapter = Adapter;
    })(Schedule = User.Schedule || (User.Schedule = {}));
    User.blockParamsSchema = zod_1.default.object({ userId: zod_1.default.string().uuid() });
    User.blockReturnSchema = zod_1.default.object({});
    User.connectGoogleParamsSchema = zod_1.default.object({ googleIdentityToken: zod_1.default.string() });
    User.connectGoogleReturnSchema = zod_1.default.object({});
    User.createParamsSchema = zod_1.default.object({
        email: zod_1.default.string().optional(),
        googleIdentityToken: zod_1.default.string().optional(),
        name: zod_1.default.string().optional(),
        phone: zod_1.default.string().optional(),
        token: zod_1.default.string().optional(),
    });
    User.createReturnSchema = zod_1.default.object({ accessToken: zod_1.default.string(), refreshToken: zod_1.default.string() });
    User.deleteParamsSchema = zod_1.default.object({ token: zod_1.default.string() });
    User.deleteReturnSchema = zod_1.default.object({});
    User.fetchParamsSchema = zod_1.default.object({});
    User.fetchReturnSchema = User.userSchema;
    User.fetchProfileParamsSchema = zod_1.default.object({ userId: zod_1.default.string().uuid().optional() });
    User.fetchProfileReturnSchema = User.profileSchema.extend({
        isBlockedByUser: zod_1.default.boolean(), // Whether the profile owner is blocked by the API-authenticated user.
    });
    User.searchParamsSchema = zod_1.default.object({
        languageCode: zod_1.default.nativeEnum(Const_1.default.languageCode).optional(),
        learning: zod_1.default.boolean().optional(),
        limit: zod_1.default.number().optional(),
        maxProficiency: zod_1.default.number().optional(),
        minProficiency: zod_1.default.number().optional(),
        offset: zod_1.default.number().optional(),
        query: zod_1.default.string().optional(),
    });
    User.searchReturnSchema = zod_1.default.object({
        count: zod_1.default.number(),
        users: User.profileSchema.extend({ lastActiveAt: zod_1.default.coerce.date().nullable() }).array(),
    });
    User.unblockParamsSchema = zod_1.default.object({ userId: zod_1.default.string().uuid() });
    User.unblockReturnSchema = zod_1.default.object({});
    User.updateParamsSchema = zod_1.default.object({
        dailyGoal: zod_1.default.nativeEnum(Const_1.default.dailyGoal).optional(),
        description: zod_1.default.string().optional(),
        interests: zod_1.default.string().array().optional(),
        localTZOffset: zod_1.default.number().optional(),
        name: zod_1.default.string().optional(),
    });
    User.updateReturnSchema = zod_1.default.object({});
    User.updateEmailParamsSchema = zod_1.default.object({ email: zod_1.default.string(), token: zod_1.default.string() });
    User.updateEmailReturnSchema = zod_1.default.object({});
    User.updatePhoneParamsSchema = zod_1.default.object({ phone: zod_1.default.string(), token: zod_1.default.string() });
    User.updatePhoneReturnSchema = zod_1.default.object({});
    User.updateProfileImageParamsSchema = zod_1.default.object({ file: zod_1.default.instanceof(File) });
    User.updateProfileImageReturnSchema = zod_1.default.object({});
    class Adapter {
        constructor(params) {
            this.api = params.api;
            this.preference = new Preference.Adapter(params);
            this.language = new Language.Adapter(params);
            this.schedule = new Schedule.Adapter(params);
        }
        block(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const { userId } = User.blockParamsSchema.parse(params);
                const response = yield this.api.request({ method: "POST", path: `/user/${userId}/block` });
                return User.blockReturnSchema.parse(response);
            });
        }
        unblock(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const { userId } = User.unblockParamsSchema.parse(params);
                const response = yield this.api.request({ method: "POST", path: `/user/${userId}/unblock` });
                return User.unblockReturnSchema.parse(response);
            });
        }
        connectGoogle(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.connectGoogleParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "POST", path: "/user/connect-google" });
                return User.connectGoogleReturnSchema.parse(response);
            });
        }
        create(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.createParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "POST", path: "/user", unauthenticated: true });
                const { accessToken, refreshToken } = response;
                yield this.api.setAccessToken(accessToken);
                this.api.refreshToken = refreshToken;
                return User.createReturnSchema.parse(response);
            });
        }
        delete(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.deleteParamsSchema.parse(params);
                yield this.api.request({ data, method: "DELETE", path: "/user" });
                yield this.api.deauthenticate();
                return {};
            });
        }
        fetch() {
            return __awaiter(this, arguments, void 0, function* (params = {}) {
                const data = User.fetchParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "GET", path: "/user" });
                return User.fetchReturnSchema.parse(response);
            });
        }
        fetchProfile() {
            return __awaiter(this, arguments, void 0, function* (params = {}) {
                const { userId } = User.fetchProfileParamsSchema.parse(params);
                let path = "/user";
                if (userId)
                    path += `/${userId}`;
                path += "/profile";
                const response = yield this.api.request({ method: "GET", path });
                return User.fetchProfileReturnSchema.parse(response);
            });
        }
        search(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.searchParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "GET", path: `/user/search` });
                return User.searchReturnSchema.parse(response);
            });
        }
        update(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.updateParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "POST", path: "/user/update" });
                return User.updateReturnSchema.parse(response);
            });
        }
        updateEmail(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.updateEmailParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "POST", path: "/user/update-email" });
                return User.updateEmailReturnSchema.parse(response);
            });
        }
        updatePhone(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = User.updatePhoneParamsSchema.parse(params);
                const response = yield this.api.request({ data, method: "POST", path: "/user/update-phone" });
                return User.updatePhoneReturnSchema.parse(response);
            });
        }
        updateProfileImage(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const { file } = User.updateProfileImageParamsSchema.parse(params);
                const data = new FormData();
                data.append("image", file);
                const response = yield this.api.request({ data, method: "POST", path: `/user/update-profile-image` });
                return User.updateProfileImageReturnSchema.parse(response);
            });
        }
    }
    User.Adapter = Adapter;
})(User || (User = {}));
exports.default = User;
